import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { ValidateDocumentTypes } from '../Types';

const machine = Machines.onValidateDocument.machine;

export const validateDocument = (
  params: ValidateDocumentTypes.IValidateDocumentServiceRequest,
): Promise<ValidateDocumentTypes.IValidateDocumentServiceResponse> => {
  return callServiceMachine(machine, { params });
};

export default { validateDocument };
